import { APP_URLS } from "./constant";
import { createBrowserHistory } from "history";
const browserHistory = createBrowserHistory();

export const goBack = () => {
  setTimeout(() => {
    browserHistory.back();
  }, 3000);
};

export const goBackByPath = () => {
  setTimeout(() => {
    window.location.replace("/#" + APP_URLS.RATEADMIN_RATES.HOME);
  }, 3000);
};
